import { SelectDropdownModule } from '../select-dropdown/select-dropdown.module';
import { TranslateModule } from '@ngx-translate/core';
import { ModalHeaderComponentModule } from '../modal-header/modal-header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ModalSelectDropdownComponent } from './modal-select-dropdown.component';


@NgModule({
  imports: [ 
    CommonModule,
    IonicModule,
    ModalHeaderComponentModule,
    TranslateModule,
    SelectDropdownModule
  ],
  declarations: [ModalSelectDropdownComponent],
  exports: [ModalSelectDropdownComponent]
})
export class ModalSelectDropdownModule {}
